/* eslint-env browser */

/*
* It is possible that there are separate instances of pulse-cis-sync in the window, for example
* if there are multiple CDN's that repeat this library. This can result in a race condition and
* environment ID's being overwritten with the last resolving request re-writing the cookie, if no
* pulse2data cookie existed before any of the requests.
*
* This issue has been observed and cisParallelRequest attempts to always resolve multiple requests
* from the first request that was made in the window. This should help have more predictable behaviour
* over environment ID's when this scenario exists.
*
* NOTE: This module assumes Browser environment.
*/

var globalCisSyncState = function globalCisSyncState() {
  window.pulseCisSync = window.pulseCisSync || {};
  var _window = window,
      pulseCisSync = _window.pulseCisSync;

  pulseCisSync.requestPromise = pulseCisSync.requestPromise || null;

  return {
    completeFetchRequest: function completeFetchRequest() {
      pulseCisSync.requestPromise = null;
    },
    getPendingFetchRequest: function getPendingFetchRequest() {
      return pulseCisSync.requestPromise;
    },
    newFetchRequest: function newFetchRequest(fetchRequest) {
      pulseCisSync.requestPromise = fetchRequest;
      return fetchRequest;
    }
  };
};

var cisParallelRequest = function cisParallelRequest(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _globalCisSyncState = globalCisSyncState(),
      newFetchRequest = _globalCisSyncState.newFetchRequest,
      getPendingFetchRequest = _globalCisSyncState.getPendingFetchRequest,
      completeFetchRequest = _globalCisSyncState.completeFetchRequest;

  var fetchRequest = getPendingFetchRequest() || newFetchRequest(fetch(url, options));

  fetchRequest.catch(function () {
    return completeFetchRequest();
  });
  return fetchRequest.then(function (response) {
    completeFetchRequest();
    return response.clone();
  });
};

export default cisParallelRequest;